// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".summary-indicator {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  margin: 0.2em;\n  box-sizing: border-box;\n  border-collapse: collapse;\n}\n.summary-indicator .avg-score {\n  font-size: 10pt;\n  padding: 1em;\n}\n", ""]);
// Exports
module.exports = exports;
